import { Box } from "@mui/material";
import CarsIcon from "@/assets/icons/home/downloadApp/cars.svg?react";
import { roadContainerStyles, roadIconStyles } from "../styles";

const Road = () => {
  return (
    <Box sx={roadContainerStyles}>
      <Box sx={roadIconStyles}>
        <CarsIcon />
      </Box>
    </Box>
  );
};

export default Road;
